import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useDownloadZip } from "./useDownloadZip";

export type InvoiceFormat = "pdf" | "excel";

/**
 * Invoice-specific wrapper around `useDownloadZip` that adds toast feedback
 * and a sensible archive filename.
 */
export const useDownloadInvoicesZip = () => {
  const { t } = useTranslation("boInvoices");
  const { download: downloadZip, isDownloading } = useDownloadZip();

  const download = async (keys: string[], format: InvoiceFormat) => {
    if (keys.length === 0) {
      toast.warning(t("downloadZip.empty"));
      return;
    }

    const result = await downloadZip(keys, {
      zipFilename: `invoices_${format}_${Date.now()}`,
    });

    if (result.succeeded === 0) {
      toast.error(t("downloadZip.error"));
      return;
    }

    if (result.failed > 0) {
      toast.warning(t("downloadZip.partialFailure", { count: result.failed }));
    } else {
      toast.success(t("downloadZip.success"));
    }
  };

  return { download, isDownloading };
};
